import { FC } from 'react';
import { IconButton, Typography } from '@mui/joy';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { NotificationItem } from '@consolidocs-ui/utils';
import { formatRelativeTime } from './notificationTime';

type NotificationRowProps = {
  notification: NotificationItem;
  onDismiss: (id: string) => void;
};

export const NotificationRow: FC<NotificationRowProps> = ({
  notification,
  onDismiss,
}) => (
  <li className={`notification-row notification-row--${notification.type}`}>
    <span className="notification-row__dot" aria-hidden />
    <div className="notification-row__body">
      <Typography level="body-sm" className="notification-row__message">
        {notification.message}
      </Typography>
      <Typography level="body-xs" className="notification-row__time">
        {formatRelativeTime(notification.timestamp)}
      </Typography>
    </div>
    <IconButton
      size="sm"
      variant="plain"
      color="neutral"
      className="notification-row__dismiss"
      onClick={() => onDismiss(notification.id)}
    >
      <CloseRoundedIcon fontSize="small" />
    </IconButton>
  </li>
);
